import { Popover } from "antd";
import { map } from "underscore";
import { ICellRendererParams } from "ag-grid-community";
import { titleCase } from "@ts/utils";
import { TClientTags } from "@ts/common-types";

interface PopOverNameCellRendererProps extends ICellRendererParams {
    tagMappingField: string;
}

const PopOverNameCellRenderer = (params: PopOverNameCellRendererProps) => {
    const recordNames = map(params.data[params.tagMappingField], (item: Partial<TClientTags>) => item.tag_type);
    const popoverContent = () => (
        <>
            <div className="fw-bold">{titleCase(params?.colDef.field)}</div>
            {map(recordNames, (item: string) => (
                <div
                    className="my-2"
                    style={{
                        fontSize: 13,
                    }}
                >
                    {item}
                </div>
            ))}
        </>
    );
    return (
        <>
            {params.node.rowPinned ? null : (
                <div>
                    <Popover
                        styles={{
                            body: {
                                padding: "18px",
                                borderRadius: "0.5rem",
                            },
                        }}
                        placement="right"
                        trigger="hover"
                        content={popoverContent}
                    >
                        <div
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "15ch",
                            }}
                        >
                            {recordNames ? recordNames[0] : ""}
                        </div>
                    </Popover>
                </div>
            )}
        </>
    );
};

export default PopOverNameCellRenderer;
